import React, { useState, useEffect, useContext } from 'react';
import { Paper, Box, Grid, Chip, Typography, Autocomplete, CircularProgress, InputAdornment, TextField, IconButton, Pagination } from '@mui/material';
import ApiService from '../../functions/apiService';
import ButtonDatePicker from '../../components/DatePickers/ButtonDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from 'moment';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import './vacation-bids.css'
import SearchIcon from "@mui/icons-material/Search";
import { toast } from 'react-toastify';
import { Col, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { varFormatTime } from '../../utils/helperFunctions';
import AuthContext from '../../context/AuthContext';
import { DataGrid } from '@mui/x-data-grid';
import { Link } from "react-router-dom";

const VacationBids = () => {
    const { user } = useContext(AuthContext)
    const [loading, setLoading] = useState(false);
    const [date, setDate] = useState(new Date());
    const [deleteModal, setDeleteModal] = useState(false)
    const [bitList, setBidList] = useState('');
    const [searchResult, setSearchResult] = useState('');
    const [group, setGroup] = useState(null);
    const [groupDrop, setGroupDrop] = useState([]);
    const [endDate, setEndDate] = useState(null);


    const columns = [
        {
            field: 'Id', headerName: 'Bid Id', flex: 1, minWidth: 200,
        },

        {
            field: 'Start_Date', headerName: 'Start Date', flex: 1, minWidth: 200,
        },

        {
            field: 'fullName', headerName: 'Name', flex: 1, minWidth: 200,
            renderCell: (params) => {
                return (
                    params?.row?.created_employee?.fullName
                )
            }
        },

        {
            field: 'action', headerName: 'Actions', flex: 1, minWidth: 130,
            renderCell: (params) => {
                return (
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <Link to={`/firehouse/vacation-bid-members/${params?.row?.Id}`}>
                            <img src='/images/eye.svg' style={{ cursor: 'pointer' }} />
                        </Link>
                    </Box >
                );
            },
        }
    ]

    const addBid = () => {
        const body = {
            "start_date": moment(date).format('YYYY-MM-DD'),
            "end_date": endDate ? moment(endDate).format('YYYY-MM-DD') : null,
            "group_code": group?.value,
        }
        ApiService.post('/vacationBid/store', body)
            .then((data) => {
                toast.success(data?.message)
                setDate(new Date());
                setGroup(null)
                setEndDate(null)
                getBidList()
            })
            .catch((error) => {
                if (error.status == 422) {
                    Object.keys(error.data.errors).map((err) => (
                        toast.error(error.data.errors[err][0])
                    ))
                }
                else {
                    toast.error(error.message)
                }
            })
    }

    const getBidList = () => {
        ApiService.get('/vacationBid')
            .then((data) => {
                const rowsWithIds = data?.data?.data?.map((item, index) => ({
                    ...item,
                    id: index + 1
                })) || [];
                setBidList(rowsWithIds);
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
            });
    };

    const getGroupDropDown = () => {
        setLoading(true);
        ApiService.get("/getGroups")
            .then(({ data }) => {
                var tempArr = []
                Object.keys(data?.data).map(val => (
                    tempArr.push({ label: data.data[val], value: val })
                ))
                setGroupDrop(tempArr)
            })
            .catch((e) => {
                setLoading(false);
            })
    }

    useEffect(() => {
        getBidList()
        getGroupDropDown()
    }, [])

    useEffect(() => {
        getBidList(false)
    }, [searchResult])

    return (
        <>
            <Paper className="p-4 font-fam" style={{ marginTop: "1rem" }}>
                <Grid container spacing={2} className='align-items-center'>

                    {/* Heading */}
                    <Grid item xs={10} md={4}>
                        <Typography variant="h5">Vacation Bids</Typography>
                    </Grid>

                    <Grid container className='p-4' spacing={2}>

                        {/* Start Date */}
                        <Grid item xs={12} sm={6} md={4} className='d-grid'>
                            <label className='my-2'>Start Date</label>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <ButtonDatePicker
                                    className='w-100'
                                    label={moment(date).format('MM/DD/YYYY')}
                                    value={date}
                                    onChange={(e) => setDate(e)}
                                />
                            </LocalizationProvider>
                        </Grid>

                        {/* Group Code */}
                        <Grid item xs={12} sm={6} md={4}>
                            <label className='my-2'>Group Code</label>
                            <Autocomplete
                                options={groupDrop}
                                onChange={(event, newValue) => setGroup(newValue)}
                                value={group}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Group"
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        sx={{
                                            "& .MuiInputBase-root": {
                                                height: "48px",
                                                fontSize: "14px",
                                                display: "flex",
                                                alignItems: "center"
                                            }
                                        }}
                                    />
                                )}
                            />
                        </Grid>

                        {/* End Date */}
                        <Grid item xs={12} sm={6} md={4} className='d-grid'>
                            <label className='my-2'>End Date</label>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <ButtonDatePicker
                                    className='w-100'
                                    label={endDate ? moment(endDate).format('MM/DD/YYYY') : 'MM/DD/YYYY'}
                                    value={endDate}
                                    onChange={(e) => setEndDate(e)}
                                />
                            </LocalizationProvider>
                        </Grid>
                    </Grid>

                    {/* Submit/Edit Button */}
                    <Grid container gap={2} className='justify-content-end'>
                        <Grid item xs={6} md={'auto'}>
                            <ButtonTheme
                                className='px-2 mt-1'
                                style={{ marginRight: '24px' }}
                                color='primary'
                                type='submit'
                                variant="filled"
                                onClick={() => { addBid() }}
                            >
                                Submit
                            </ButtonTheme>
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>

            {loading ? (
                <Paper className="w-100 h-100 d-flex justify-content-center align-items-center font-fam">
                    <CircularProgress />
                </Paper>
            ) : (
                <Paper className="p-4 font-fam" style={{ marginTop: "1rem" }}>
                    <Grid container spacing={2}>

                        {/* Heading */}
                        <Grid item xs={10} md={9}>
                            <Typography variant="h6">List of Vacation Bids</Typography>
                        </Grid>
                    </Grid>

                    {(!bitList || bitList.length == 0) ?
                        <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 325 }}>
                            <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                            <span className='mt-4' style={{ color: '#555555' }}>
                                No Bids Found
                            </span>
                        </div>
                        :
                        <>
                            <div className='mt-4'>
                                <DataGrid
                                    rows={bitList}
                                    columns={columns}
                                    checkboxSelection={false}
                                    hideFooter={true}
                                />
                            </div>
                        </>
                    }

                    {/* Delete Modal */}
                    <Modal show={deleteModal} onHide={() => setDeleteModal(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>Delete Assignment</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <div style={{ color: '#555555' }}>
                                Are you sure you want to delete this Assignment?
                            </div>
                            <Row>
                                <Col md='auto'>
                                    <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => {
                                        setDeleteModal(false)
                                    }}>
                                        Cancel
                                    </ButtonTheme>
                                </Col>

                                <Col md='auto'>
                                    <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4'
                                    // onClick={deleteAssignment}
                                    >
                                        Delete
                                    </ButtonTheme>
                                </Col>

                            </Row>
                        </Modal.Body>
                    </Modal>
                </Paper >
            )}
        </>
    )
}

export default VacationBids

// const deleteAssignment = () => {
//     const body = {
//         'id': deleteId,
//     }
//     ApiService.post('/position-assignment/delete', body)
//         .then((data) => {
//             setDeleteModal(false)
//             toast.success(data.message)
//             getBidList()
//         })
//         .catch((err) => {
//             toast.error(err?.data?.error)
//         })
// }